import React, { FC, useEffect, useState } from 'react'
import applicantsService from '../../../../Services/applicantsService'
import Loader from '../../../../Components/Loader/Loader'
import './Dashboard.scss'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { useForm } from 'react-hook-form'
import useLoggedInUser from '../../../../Hooks/useLoggedInUser'

const AutomatedInterview: FC = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<{nin:string}>()
  const [loadingData, setLoadingData] = useState(false)
  const [submit, setSubmit] = useState<boolean>(false)

  const [statistics, setStatistics] = useState({
    jobId: 1,
    totalSchedule: 0,
    totalScreened: 0,
    totalUnscreen: 0
  })

  const [renew, setRenew] = useState(1)
  const navigate = useNavigate()
  const logged = useLoggedInUser()

  const getStatistics = async () => {
    setLoadingData(true)
    try {
      const res = await applicantsService.getStatistics(renew)
      setStatistics(res.data.dataset)
    } catch (error: any) {
      console.error('getStatistics ERROR', error)
    } finally {
      setLoadingData(false)
    }
  }

  useEffect(() => {
    getStatistics()
  }, [renew])

  useEffect(() => {
    const Setting = async () => {
      try {
        const settings = await applicantsService.getSetting()
        const admissionId = settings.data.dataset.admissionId
        localStorage.setItem('admissionId', admissionId)
      } catch (error) {
        console.error('SETERROR', error)
      }
    }
    Setting()

    const timer = setTimeout(() => setRenew(0), 18000)
    return () => clearTimeout(timer)
  }, [])

  const onSubmit = handleSubmit(async (data) => {
    setSubmit(true)
    try {
      const res = await applicantsService.getSingleApplicant(data.nin)
      navigate(`/automatedapplicant/${res.data.dataset.nimc.nin}`, { replace: false })
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Failed to fetch applicant', {
        duration: 5000,
        className: 'error-toast'
      })
    } finally {
      setSubmit(false)
    }
  })

  const isAcademicOfficer = logged.mainRole === 'pscreen_academic_officer'

  return (
    <div className="dashboard-modern">
      {/* Header Section */}
      <div className="dashboard-header">
        <div className="container">
          <div className="welcome-section">
            <div className="welcome-card">
              <div className="welcome-content">
                <div className="welcome-text">
                  <h1 className="welcome-title">Welcome back, {logged.username}</h1>
                  <p className="welcome-subtitle">Physical / Credentials Screening Module Dashboard</p>
                </div>
                <div className="user-badge">
                  <div className="badge-icon">
                    <i className="fa fa-user-circle"></i>
                  </div>
                </div>
              </div>

              <div className="zone-info">
                {/* <div className="zone-item">
                  <span className="zone-label">Zone</span>
                  <span className="zone-value">{logged.zone}</span>
                </div> */}
                <div className="zone-divider"></div>
                <div className="zone-item">
                  <span className="zone-label">States</span>
                  <span className="zone-value">
                     <span className="state-tag"> {logged.stateOfOperationName}
                    </span>
                  </span>
                </div>
                <div className="zone-divider"></div>
                 <div className="zone-item">
                  <span className="zone-label">Role</span>
                  <span className="zone-value">{logged.mainRole === 'pscreen_academic_officer' ? 'PSC Data officer' : 'NPF Data Officer' }</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="statistics-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card stat-primary" onClick={() => navigate('/applicants', { replace: false })}>
              <div className="stat-icon">
                <i className="fa fa-users"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{loadingData ? '...' : statistics?.totalSchedule?.toLocaleString() || 0}</h3>
                <p className="stat-title">Overall Applications</p>
                <span className="stat-desc">Total applications received</span>
              </div>
              <div className="stat-trend">
                <i className="fa fa-arrow-up"></i>
              </div>
            </div>

            <div className="stat-card stat-success">
              <div className="stat-icon">
                <i className="fa fa-user-check"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{loadingData ? '...' : statistics?.totalScreened?.toLocaleString() || 0}</h3>
                <p className="stat-title">Screened Candidates</p>
                <span className="stat-desc">Total applicants screened</span>
              </div>
              <div className="stat-trend success">
                <i className="fa fa-check-circle"></i>
              </div>
            </div>

            <div className="stat-card stat-warning">
              <div className="stat-icon">
                <i className="fa fa-clock"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{loadingData ? '...' : statistics?.totalUnscreen?.toLocaleString() || 0}</h3>
                <p className="stat-title">Pending Screening</p>
                <span className="stat-desc">Awaiting verification</span>
              </div>
              <div className="stat-trend warning">
                <i className="fa fa-hourglass-half"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="search-section">
        <div className="container">
          <div className="search-card">
            <div className="search-header">
              <div className="search-icon-wrapper">
                <i className="fa fa-search"></i>
              </div>
              <div className="search-title-wrapper">
                <h2 className="search-title">
                  {isAcademicOfficer
                    ? 'PSC Credentials Screening'
                    : 'NPF Physical Screening'}
                </h2>
                <p className="search-subtitle">Search for candidate by National Identification Number</p>
              </div>
            </div>

            <form className="search-form" onSubmit={onSubmit}>
              <div className="search-input-wrapper">
                <label className="search-label">National Identification Number (NIN)</label>
                <div className="input-group">
                  <span className="input-icon">
                    <i className="fa fa-id-card"></i>
                  </span>
                  <input
                    type="text"
                    className={`search-input ${errors.nin ? 'error' : ''}`}
                    placeholder="Enter 11-digit NIN"
                    maxLength={11}
                    {...register('nin', {
                      required: 'NIN is required',
                      pattern: {
                        value: /^[0-9]{11}$/,
                        message: 'NIN must be 11 digits'
                      }
                    })}
                  />
                </div>
                {errors.nin && (
                  <div className="error-message">
                    <i className="fa fa-exclamation-circle"></i>
                    {errors.nin.message}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className="search-button"
                disabled={submit}
              >
                {submit
                  ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </>
                    )
                  : (
                  <>
                    <i className="fa fa-search me-2"></i>
                    Search Candidate
                  </>
                    )}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#333',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }}
      />
      <Loader show={loadingData} />
    </div>
  )
}

export default AutomatedInterview
